import hasDocuments from 'api/v2/repository/hasDocuments';
import SimpleError from 'components/molecules/SimpleError.component';
import { useQuery } from 'react-query';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import DocumentsOnboarding from './DocumentsOnboarding.component';
import DocumentsRepository from './DocumentsRepository.component';
import DocumentsRepositoryLoadingSkeleton from './DocumentsRepositoryLoadingSkeleton';

const DocumentsRepositoryIntro = () => {
  const userHasDocs = useQuery(
    DocumentsRepositoryCacheKeys.HasDocuments,
    hasDocuments,
    {
      staleTime: 0,
    },
  );

  if (userHasDocs.isError) {
    return (
      <SimpleError
        onRetry={() => {
          if (userHasDocs.isError) userHasDocs.refetch();
        }}
      />
    );
  }

  if (userHasDocs.isLoading) {
    return <DocumentsRepositoryLoadingSkeleton />;
  }

  if (userHasDocs.data) return <DocumentsRepository />;

  return <DocumentsOnboarding />;
};

export default DocumentsRepositoryIntro;
